// sidc.js — tiny helpers for hand-authoring MIL-STD-2525 20-digit SIDCs for the map-editor
// demo scenarios under src/dev/mapDemo. This is NOT a general-purpose SIDC builder — see
// src/components/mapEditor/SidcBuilder.jsx for the real interactive one used in the app itself.
//
// Every SIDC produced here deliberately leaves the entity/entityType/entitySubType digits at
// "0" (a generic affiliation-colored frame for the chosen symbol set) rather than guessing at
// specific entity codes: the full ~5,750-entry entity catalogue lives inside the
// `@armyc2.c5isr.renderer/mil-sym-ts-web` package, not in this repo's source, so there is no
// safe local way to hand-author e.g. "mechanized infantry" vs. "artillery" entity digits without
// risking an invalid/blank icon. A unit's specific identity is instead conveyed the same way
// real 2525 users commonly do it: readable text amplifiers (`sidcModifiers.T_UNIQUE_DESIGNATION_1`,
// `M_HIGHER_FORMATION`, `AS_COUNTRY`) plus the marking's own `label` — see scenario files.
//
// See .scratch/map-editor-demo/PLAN.md for the full write-up.

export const AFFILIATION = {
    PENDING: '0',
    UNKNOWN: '1',
    ASSUMED_FRIEND: '2',
    FRIEND: '3',
    NEUTRAL: '4',
    SUSPECT: '5',
    HOSTILE: '6',
};

export const SYMBOL_SET = {
    AIR: '01',
    AIR_MISSILE: '02',
    SPACE: '05',
    LAND_UNIT: '10',
    CIVILIAN_UNIT: '11',
    LAND_EQUIPMENT: '15',
    LAND_INSTALLATION: '20',
    CONTROL_MEASURE: '25',
    DISMOUNTED: '27',
    SEA_SURFACE: '30',
    SEA_SUBSURFACE: '35',
};

/**
 * Build a generic-entity 20-digit SIDC: [version=10][context=0][affiliation][symbolSet][14 zeros].
 */
export function sidc(affiliation, symbolSet) {
    return `10${'0'}${affiliation}${symbolSet}${'0'.repeat(14)}`;
}

// Confirmed-good tactical graphic (Control Measure symbol set 25) SIDCs, reused verbatim from
// this repo's own test suite (see useMapEditor.line1DoA.sidcWiring.test.js /
// line1DirectionOfAttackTools.test.js), where each is exercised against the real
// TacticalRenderer/WebRenderer — safe to reuse here rather than guessing new ones.
export const TACTICAL_SIDC = {
    FLOT: '11032500001401000000', // Forward Line of Own Troops
    DIRATK_GROUND: '11032500001406020000', // Direction of Attack, Ground
    DIRATK_AIR: '11032500001406010000', // Direction of Attack, Air/Aviation
    DIRATK_SUPPORTING: '11032500001406030000', // Direction of Attack, Supporting
};
